import { render, staticRenderFns } from "./Examiner.vue?vue&type=template&id=1ff10b0f&"
import script from "./Examiner.vue?vue&type=script&lang=js&"
export * from "./Examiner.vue?vue&type=script&lang=js&"
import style0 from "./Examiner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports